import React from 'react';
import { Box, Typography, Stepper, Step, StepLabel } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

const steps = [
    'Initial Request',
    'Initial Approval',
    'Complete Influencer Profile',
    'Profile Verification',
    'Start Receiving Briefs',
];

interface InfluencerOnboardingProgressProps {
    activeStep?: number;
    readOnly?: boolean;
}

const InfluencerOnboardingProgress: React.FC<InfluencerOnboardingProgressProps> = ({ activeStep = 0, readOnly }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box sx={{ width: { xs: '100%', sm: '70%' }, py: 4, px: 2 }}>
            <Typography variant="h5" align="center" sx={{ mb: 4, fontWeight: 700, color: theme[themeStyle].tag_white }}>
                Onboarding Steps
            </Typography>

            <Stepper
                alternativeLabel
                activeStep={readOnly ? steps.length : activeStep}
                sx={{
                    '& .MuiStepConnector-line': {
                        borderColor: theme[themeStyle].tag_white,
                        borderTopWidth: 2,
                    },
                    '& .MuiStepLabel-label': {
                        fontWeight: 500,
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    },
                    '& .MuiStepIcon-root.Mui-completed': {
                        color: theme[themeStyle].highlight,
                    },
                }}>
                {steps.map(label => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export { InfluencerOnboardingProgress };
